<template>
  <div class="d-flex align-items-center battle-cover battle-cover-small">
    <portal to="header-left-portal" class="row align-items-center ">
      <GoBackBtn history-mode hide-label />
      <TextBlock
        :text="
          `${dynamicBattleModel.tournament.name}  /  ${$$t('Battle')} #${
            dynamicBattleModel.id
          }`
        "
        :size="1.25"
        class="secondary-font"
        variant="bold"
      />
    </portal>
    <div
      class="d-flex flex-column col-4 smaller-screen-width justify-content-between p-5 tournament-info-battles"
    >
      <TournamentCardOrganizer
        class="battle-tournament-organizer"
        :tournament="dynamicBattleModel.tournament"
        :size="48"
      />
      <div class="info-block">
        <StatusLabel
          :status="dynamicBattleModel.status"
          class="battle-status-label mb-4"
        />
        <router-link
          :to="(path = `/tournament/${dynamicBattleModel.tournament.id}`)"
          class="tournament-link"
        >
          <TextBlock
            :text="dynamicBattleModel.tournament.name"
            tag="h1"
            :size="1.5"
            class="secondary-font tournament-link"
            variant="bold"
          />
        </router-link>
        <div v-if="platform" class="d-flex align-items-center">
          <div class="h-mr-2">
            <!-- <Avatar
              v-if="platform.logo"
              :img-url="platform.logo.uri"
              type="platform"
              :alt="platform.name"
              :size="28"
            /> -->
            <TournamentCardPlatform
              class="font-size-sm text-block--muted"
              :tournament="dynamicBattleModel.tournament"
            />
          </div>
          <TextBlock
            v-if="game"
            :variant="'muted'"
            :text="' � '"
            class="h-mr-2"
          />
          <TextBlock v-if="game" :variant="'muted'" :text="game.name" />
        </div>

        <div v-if="countdownOptions.date" class="row align-items-center">
          <div class="date-label data-tournament-label  ">
            <TextBlock
              :text="countdownOptions.text"
              size="0.875"
              :variant="['muted']"
              tag="p"
              class="mb-0"
            />
            <span>{{
              countdownOptions.date
                | localDate($times.DATETIMEWEEKDAY_MED, true)
            }}</span>
          </div>

          <Countdown
            :date="countdownOptions.date"
            :separator="' : '"
            class="font-size-sm mb-0 battle-countdown"
          />
        </div>
      </div>
    </div>
    <div class="col-4 smaller-screen-width">
      <!-- <TextBlock
        :text="statusText"
        tag="p"
        class="battle-cover_status text-center"
      /> -->
      <div
        class="d-flex justify-content-center"
        :class="{ 'flex-row-reverse': reversePlayers }"
      >
        <BattleAccount
          :player="
            isDuelMatch
              ? dynamicBattleModel.players[0] &&
                dynamicBattleModel.players[0].profile
              : dynamicBattleModel.players[playerIndex] &&
                (dynamicBattleModel.players[playerIndex].profile || {})
          "
          :host="isDuelMatch"
          :is-winner="
            isBattleCompleted &&
              (isDuelMatch
                ? isPlayerOneWin
                : dynamicBattleModel.players[playerIndex] &&
                  dynamicBattleModel.players[playerIndex].rank === 1)
          "
        />
        <template v-if="isDuelMatch">
          <div class="pt-4">
            <TextBlock
              :text="resultsLabel"
              :size="resultsLabelSize"
              class="text-nowrap"
            />
            <TextBlock
              v-if="isDraw"
              class="battle-cover_draw text-center mb-0"
              :text="$$t('Draw')"
              tag="p"
            />
          </div>
          <BattleAccount
            :player="
              (dynamicBattleModel.players[1] &&
                dynamicBattleModel.players[1].profile) ||
                {}
            "
            :is-winner="isBattleCompleted && isPlayerTwoWin"
          />
        </template>
        <template v-else>
          <Panel
            :variant="['transparent']"
            class="h-mr-3 flex-shrink-0 px-4 py-3 d-flex flex-column align-items-center justify-content-around"
          >
            <TextBlock
              :variant="['primary']"
              :line-height="1"
              :size="1.375"
              :style="{ minWidth: '15px' }"
              class="text-center"
            >
              {{ dynamicBattleModel.players[playerIndex].rank }}
            </TextBlock>
            <TextBlock
              :variant="['secondary']"
              :line-height="1"
              :style="{ minWidth: '15px' }"
            >
              {{ $t('_web_account_battle_info_card_rank', 'Rank') }}
            </TextBlock>
          </Panel>
          <Panel
            :variant="['transparent']"
            class="flex-shrink-0 px-4 py-3 d-flex flex-column align-items-center justify-content-around"
          >
            <TextBlock
              :variant="['primary']"
              :line-height="1"
              :size="1.375"
              :style="{ minWidth: '15px' }"
              class="text-center"
            >
              {{ dynamicBattleModel.players[playerIndex].score }}
            </TextBlock>
            <TextBlock
              :variant="['secondary']"
              :line-height="1"
              :style="{ minWidth: '15px' }"
            >
              {{ $t('_web_account_battle_info_card_kills', 'Kills') }}
            </TextBlock>
          </Panel>
        </template>
      </div>
    </div>
    <div
      class="col-4 d-flex justify-content-end align-items-end p-5 sponsors-battle"
    >
      <!-- <BattleStatusPanel
        v-if="
          !isBattleCompleted &&
            !isBattleJudging &&
            dynamicBattleModel.isParticipant
        "
        class="battle-cover_card-wrap"
        hide-countdown
      /> -->
      <div v-if="sponsorsLogos" class="sponosors-smaller-screen pt-3 d-flex">
        <img
          v-for="sponsor in sponsorsLogos"
          :key="sponsor"
          :src="sponsor"
          height="76"
          class="h-mr-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { BLOCK_TYPES } from '@/constants/tournaments';
import { BATTLE_STATUSES, POSSIBLE_RESULTS } from '@/constants/battles';
import { translate } from '@/mixins/translate';
// import Avatar from '@/components/images/Avatar';
import TextBlock from '@/components/atoms/TextBlock';
import StatusLabel from '@/components/molecules/StatusLabel';
import Panel from '@/components/atoms/Panel';
import BattleAccount from './BattleAccount';
// import BattleStatusPanel from '@/views/account/content/results/BattleStatusPanel.vue';
import TournamentCardPlatform from '@/components/common/TournamentCard/components/Platform.vue';
import TournamentCardOrganizer from '@/components/common/TournamentCard/components/Organizer.vue';
import Countdown from '@/components/common/Countdown.vue';
import GoBackBtn from '@/components/common/GoBackBtn.vue';
import { DEFAULT } from '@/constants/common';

export default {
  name: 'Battle',
  components: {
    // BattleStatusPanel,
    GoBackBtn,
    Panel,
    // Avatar,
    TextBlock,
    BattleAccount,
    StatusLabel,
    Countdown,
    TournamentCardOrganizer,
    TournamentCardPlatform,
  },
  mixins: [translate('_web_battle')],
  data() {
    return {
      roomId: '',
      interval: null,
      currentDate: Date.now() / 1e3,
      finishBattleLoading: false,
      startBattleLoading: false,
      confirmBattleLoading: false,
      statuses: {
        [BATTLE_STATUSES.started]: this.$$t('In Progress'),
        [BATTLE_STATUSES.pending]: this.$$t('Pending'),
        [BATTLE_STATUSES.completed]: this.$$t('Completed'),
        [BATTLE_STATUSES.scheduled]: this.$$t('Scheduled'),
        [BATTLE_STATUSES.cancelled]: this.$$t('Cancelled'),
        [BATTLE_STATUSES.judging]: this.$$t('Judging'),
      },
    };
  },
  computed: {
    ...mapState('my', {
      myAccountId: 'accountId',
      myAccount: 'account',
    }),
    ...mapGetters([
      'dynamicBattleModel',
      'platformByID',
      'gameByID',
      'currentCountry',
    ]),
    isDuelMatch() {
      return this.dynamicBattleModel.type !== BLOCK_TYPES.BATTLE_ROYALE;
    },
    isBattleCompleted() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.completed;
    },
    isBattleJudging() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.judging;
    },
    hasPlayers() {
      return (
        Array.isArray(this.dynamicBattleModel.players) &&
        this.dynamicBattleModel.players.length
      );
    },
    isDraw() {
      return (
        this.hasPlayers &&
        this.dynamicBattleModel.players[this.playerIndex] &&
        this.dynamicBattleModel.players[this.playerIndex].result ===
          POSSIBLE_RESULTS.draw
      );
    },
    resultsLabel() {
      let label = '';
      switch (this.dynamicBattleModel.status) {
        case BATTLE_STATUSES.cancelled:
          label = '-';
          break;
        case BATTLE_STATUSES.started:
        case BATTLE_STATUSES.pending:
          label = this.$$t('vs');
          break;
        case BATTLE_STATUSES.completed:
          label = this.completedLabel;
          break;
      }
      return label;
    },
    completedLabel() {
      const firstPlayerScore =
        (this.dynamicBattleModel.players[0] &&
          this.dynamicBattleModel.players[0].score) ||
        0;
      const secondPlayerScore =
        (this.dynamicBattleModel.players[1] &&
          this.dynamicBattleModel.players[1].score) ||
        0;
      if (this.reversePlayers) {
        return `${(this.dynamicBattleModel.players[1] &&
          this.getWinLoseText(this.dynamicBattleModel.players[1].result)) ||
          secondPlayerScore} - ${(this.dynamicBattleModel.players[0] &&
          this.getWinLoseText(this.dynamicBattleModel.players[0].result)) ||
          firstPlayerScore}`;
      }
      return `${(this.dynamicBattleModel.players[0] &&
        this.getWinLoseText(this.dynamicBattleModel.players[0].result)) ||
        firstPlayerScore} - ${(this.dynamicBattleModel.players[1] &&
        this.getWinLoseText(this.dynamicBattleModel.players[1].result)) ||
        secondPlayerScore}`;
    },
    resultsLabelSize() {
      const result =
        this.dynamicBattleModel.players[this.playerIndex] &&
        this.dynamicBattleModel.players[this.playerIndex].result;
      return this.dynamicBattleModel.status === BATTLE_STATUSES.completed &&
        [POSSIBLE_RESULTS.techLoss, POSSIBLE_RESULTS.techWin].includes(result)
        ? 1
        : 2;
    },
    platform() {
      return this.platformByID(this.dynamicBattleModel.platform) || {};
    },
    game() {
      return this.gameByID(this.dynamicBattleModel.game) || {};
    },
    statusText() {
      return this.statuses[this.dynamicBattleModel.status]
        ? this.statuses[this.dynamicBattleModel.status]
        : this.dynamicBattleModel.status;
    },
    playerIndex() {
      return this.dynamicBattleModel.myIndex !== null
        ? this.dynamicBattleModel.myIndex
        : 0;
    },
    isPlayerOneWin() {
      return (
        this.dynamicBattleModel.players[0] &&
        this.isWinner(
          this.dynamicBattleModel.players[0].result,
          this.dynamicBattleModel.players[0].scored,
          this.dynamicBattleModel.players[1] &&
            this.dynamicBattleModel.players[1].scored
        )
      );
    },
    countdownOptions() {
      let text = '',
        date;
      switch (this.dynamicBattleModel.status) {
        case BATTLE_STATUSES.scheduled:
          text = this.$$t('Battle will start');
          date = this.dynamicBattleModel.activationDate;
          break;
        case BATTLE_STATUSES.pending:
          text = this.$$t('Start battle in next');
          date = this.dynamicBattleModel.startDate;
          break;
        case BATTLE_STATUSES.started:
          text = this.$$t('Provide results in next');
          date = this.dynamicBattleModel.endDate;
          break;
      }
      date = date && this.currentDate < date ? date : null;
      return { text, date };
    },
    isPlayerTwoWin() {
      return (
        this.dynamicBattleModel.players[1] &&
        this.isWinner(
          this.dynamicBattleModel.players[1].result,
          this.dynamicBattleModel.players[1].scored,
          this.dynamicBattleModel.players[0] &&
            this.dynamicBattleModel.players[0].scored
        )
      );
    },
    reversePlayers() {
      return this.isDuelMatch && !!this.playerIndex;
    },
    sponsorsLogos() {
      let sponsors =
        this.dynamicBattleModel.tournament.sponsorLogo ||
        this.dynamicBattleModel.tournament.sponsor_logo ||
        [];
      return sponsors[this.currentCountry] || sponsors[DEFAULT];
    },
  },
  created() {
    this.roomId = this.dynamicBattleModel.battleInfo;
    //TODO think about changing to requestAnimationFrame
    this.interval = setInterval(
      () => (this.currentDate = Date.now() / 1e3),
      1000
    );
    this.getBattleResults({
      battleID: this.dynamicBattleModel.id,
      rounds:
        this.dynamicBattleModel.numberOfRounds ||
        this.dynamicBattleModel.numberOfMatches,
    }).catch(this.errorNotify);
    this.toggleBattleSubscriber();
  },
  destroyed() {
    clearInterval(this.interval);
    this.toggleBattleSubscriber(true);
  },
  methods: {
    ...mapActions([
      'startBattle',
      'finishBattle',
      'errorNotify',
      'getBattleResults',
      'addSystemSubscriber',
      'removeSystemSubscriber',
    ]),
    ...mapMutations(['updateBattleFromSubscriber']),
    isWinner(result, score1, score2) {
      return !result
        ? score1 > score2
        : result === POSSIBLE_RESULTS.techWin ||
            result === POSSIBLE_RESULTS.win;
    },
    getWinLoseText(result) {
      return result === POSSIBLE_RESULTS.techWin
        ? this.$$t('Win', 'win')
        : result === POSSIBLE_RESULTS.techLoss
        ? this.$$t('Lose', 'lose')
        : null;
    },
    toggleBattleSubscriber(remove = false) {
      if (remove) {
        this.removeSystemSubscriber(this.subscriber);
      } else {
        this.addSystemSubscriber(this.subscriber);
      }
    },
    subscriber(data) {
      this.updateBattleFromSubscriber({
        battleId: this.dynamicBattleModel.id,
        myId: this.myAccountId,
        data,
      });
    },
  },
};
</script>

<style lang="scss">
.battle-cover {
  background: rgba(28, 28, 36, 0.84);
  a:hover {
    text-decoration: none !important;
    color: inherit;
  }
  &_status {
    font-size: 1rem;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 12.72%,
      rgba(255, 255, 255, 0.3) 50.28%,
      rgba(255, 255, 255, 0) 87.87%
    );
  }
  &_card {
    flex-basis: 292px;
  }
  &_room-id {
    // border-top: 1px dashed $ph-secondary-text;
    .btn {
      min-width: 4rem;
    }
  }
  &_room-id-copy {
    top: 0;
    @include auto-rtl(right, 0);
  }
  &_draw {
    background-color: $ph-secondary-text;
    border-radius: 2rem;
  }

  .battle-status-label {
    border-radius: 0.5rem;
    min-width: unset !important;
    color: unset;
    span {
      line-height: 1rem;
      font-weight: 600;
    }
  }
  .battle-countdown {
    font-family: 'Roboto Mono';
    margin-left: 16px;
    @include auto-rtl(margin-left, 16px);
  }
}
.data-tournament-label {
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
}
.tournament-info-battles {
  height: 100%;
}
.sponsors-battle {
  height: 100%;
}
.battle-cover-small {
  height: 100%;
}
@media (max-width: 980px) {
  .smaller-screen-width {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .sponosors-smaller-screen {
    display: none !important;
  }
  .battle-cover-small {
    flex-direction: column;
    height: unset;
  }
  .tournament-info-battles {
    height: unset;
  }
  .sponsors-battle {
    height: unset;
    flex: 0 0 100%;
    max-width: 100%;
    min-height: 200px;
  }
}
</style>
